import React, { useState, useEffect } from 'react';
import LangSwitcher from '../components/LangSwitcher/LangSwitcher';
import Bloc from '../components/Blocs/Bloc';
import Button from '../components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { ContentWrapper, ContentBloc } from '../styles/common';
import { clearMoleculesCache } from '../helpers/localStorage';
import { getMoleculesWithRates } from '../services/molecules';
import { getTranslations } from '../services/translations';
import { transformTranslations } from '../helpers/transformTranslations';
import i18n from '../i18n';
import { getConsent, clearConsent, CONSENT, CONSENT_CHANGED_EVENT } from '../helpers/consent';

const Settings = () => {

  const { t } = useTranslation();
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(null);
  const [consent, setConsentState] = useState(getConsent());

  useEffect(() => {
    const onChange = (e) => setConsentState(e.detail);
    window.addEventListener(CONSENT_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, onChange);
  }, []);

  const consentStatusKey = consent === CONSENT.ACCEPTED
    ? 'cookieStatusAccepted'
    : consent === CONSENT.REFUSED ? 'cookieStatusRefused' : 'cookieStatusNone';

  const handleUpdate = async () => {
    setIsUpdating(true);
    setUpdateStatus(null);
    try {
      const molecules = await getMoleculesWithRates();
      const sorted = molecules.sort((a, b) => a.id - b.id);
      localStorage.setItem('molecules', JSON.stringify(sorted));
      localStorage.setItem('moleculesDate', new Date());
      localStorage.setItem('data-present', true);

      const apiTranslations = await getTranslations();
      const translations = transformTranslations(apiTranslations);
      i18n.addResourceBundle('fr', 'translation', translations.fr.translation, true, true);
      i18n.addResourceBundle('en', 'translation', translations.en.translation, true, true);

      setUpdateStatus('success');
    } catch (e) {
      setUpdateStatus('error');
    } finally {
      setIsUpdating(false);
    }
  };

  const handleCacheAndUpdate = () => {
    clearMoleculesCache();
    handleUpdate();
  };

  return (
    <ContentWrapper>
      <ContentBloc>
        <Bloc
          bgColor='#E5F1F8'
          color='#0C2566'>
          <h3>{t('languages')}</h3>
          <LangSwitcher/>
        </Bloc>
        <Bloc
          bgColor='#E5F1F8'
          color='#0C2566'
          textSize='normal'>
          <h3>{t('updateDataTitle')}</h3>
          <p>{t('updateDataDescription')}</p>
          {updateStatus === 'success' && <p style={{color: '#045F61', fontWeight: 'bold'}}>{t('updateDataSuccess')}</p>}
          {updateStatus === 'error' && <p style={{color: '#B33C36', fontWeight: 'bold'}}>{t('updateDataError')}</p>}
          <div onClick={!isUpdating ? handleCacheAndUpdate : undefined}>
            <Button
              label={isUpdating ? t('updateDataLoading') : t('updateDataButton')}
              bgColor={isUpdating ? '#AAAAAA' : '#0C2566'}
              color='#FFFFFF'
            />
          </div>
        </Bloc>
        <Bloc
          bgColor='#E5F1F8'
          color='#0C2566'
          textSize='normal'>
          <h3>{t('mentions')}</h3>
          <p>{t('mentionsText')}</p>
        </Bloc>
        <Bloc
          bgColor='#E5F1F8'
          color='#0C2566'
          textSize='normal'>
          <h3>{t('cookieManageTitle')}</h3>
          <p>{t('cookieManageText')}</p>
          <p style={{fontWeight: 'bold'}}>{t(consentStatusKey)}</p>
          <div onClick={clearConsent}>
            <Button
              label={t('cookieManageButton')}
              bgColor='#0C2566'
              color='#FFFFFF'
            />
          </div>
        </Bloc>
      </ContentBloc>
      <ContentBloc>
        <Bloc
          bgColor='#E5F8F4'
          color='#045F61'
          textSize='normal'>
          <h3>{t('warningTitle')}</h3>
          <p dangerouslySetInnerHTML={{__html: t('warningsText')}}></p>
        </Bloc>
      </ContentBloc>
    </ContentWrapper>
  )
}

export default Settings